import { useEffect, useState } from 'react';
import { ReactComponent as CloseIcon } from '../../assets/icons/trvto_close.svg';
import { ReactComponent as Close } from '../../assets/icons/trvto_closeWhite.svg';
import { orgGuidListData } from '../../api/orgGuidAPI';
import { SingleDatePicker } from 'react-dates';
import handleChange from '../../utils/handleChange';
import moment from 'moment';
import UserDetails from './constants/UserDetails';
import Price from './constants/Price';
import handleSubmit from './handleSubmit/handleSubmit';
import fetchTripData, { fetchTripDate } from './handleSubmit/fetchData';
import PlaceSelection from '../../pages/guideDetails/guideBookingTab/guideBookingTabFun/bookingTab/PlaceSelection';

const getTotalPrice = (actual, people, count, perPersonPrice) => {
    if (!people) return 0;

    if (people <= count) {
        return actual;
    }

    const extraPeople = people - count;

    return actual + extraPeople * perPersonPrice;
};

export default function AddBookingOthers({ setAddBo }) {
    const [tourList, setTourList] = useState([]);
    const [loading, setLoading] = useState(false);
    const [bookingData, setBookingData] = useState({
        guTourId: '-1',
        timeSlots: '',
        language: '',
        people: 1,
        amountPaid: {
            actual: 0,
            tax: 0,
            paid: null,
            reserve: 0,
            total: 0,
            isReserved: false,
            isInstallment: false
        },
        userDetails: []
    });
    const numPeople = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12];
    const isMobile = window.innerWidth < 768;
    const [timeSlots, setTimeSlots] = useState([]);
    const [meetUpPoints, setMeetUpPoints] = useState([]);
    const [focusedInput, setFocusedInput] = useState(null);
    const [showSelector, setShowSelector] = useState(false);
    const [packData, setPackData] = useState({});

    useEffect(() => {
        const fetchTours = async () => {
            try {
                const res = await orgGuidListData();
                setTourList(res.data);
            } catch (error) {
                console.error('Error:', error);
            }
        };

        fetchTours();
    }, []);

    useEffect(() => {
        if (bookingData.guTourId && bookingData.guTourId !== '-1') {
            fetchTripData('gu', bookingData?.guTourId, setLoading, setPackData);
        }
    }, [bookingData.guTourId, tourList]);

    useEffect(() => {
        if (!bookingData?.date) return;

        const getTripDate = async () => {
            const dateOnly = moment(bookingData.date).format('YYYY-MM-DD');
            const tripDate = await fetchTripDate({ date: dateOnly, contentId: bookingData.guTourId }, 'gu');
            const availableSlots = tripDate?.slots.filter(
                (slot) => slot.availableSlots > 0 && slot.totalSlots - slot.bookedSlots > 0
            );
            setBookingData((prev) => ({
                ...prev,
                guDatesId: tripDate?._id || ''
            }));

            setTimeSlots(availableSlots || []);
        };
        setMeetUpPoints(packData?.meetupLocation);
        getTripDate();
    }, [bookingData.date]);

    // Price calculation — driven by selected place + people count
    useEffect(() => {
        if (!packData?.price) return;

        const selectedPrice = packData.price.find(
            (price) => String(price.placeId) === String(bookingData?.selectedPlaceId)
        );

        const people = Number(bookingData?.people || 0);

        if (!selectedPrice || people <= 0) {
            return;
        }

        const actual = getTotalPrice(
            Number(selectedPrice?.actual || 0),
            people,
            Number(selectedPrice?.count || 1),
            Number(selectedPrice?.perPersonPrice || 0)
        );
        const tax = Math.round(actual * 0.05);
        const total = actual + tax;

        setBookingData((prev) => ({
            ...prev,
            amountPaid: {
                ...prev.amountPaid,
                actual,
                tax,
                total,
                reserve: selectedPrice.reserve || 0
            }
        }));
    }, [bookingData.people, bookingData.selectedPlaceId, packData]);

    function handleUser(e, index) {
        if (Array.isArray(e)) {
            setBookingData((prevState) => ({
                ...prevState,
                userDetails: e
            }));
            return;
        }
        setBookingData((prevState) => ({
            ...prevState,
            userDetails: prevState?.userDetails?.length
                ? prevState.userDetails.map((obj, objIndex) =>
                      objIndex === index ? { ...obj, [e.target.name]: e.target.value } : obj
                  )
                : [{ [e.target.name]: e.target.value }]
        }));
    }

    function handleAmount(e, type, number = true) {
        const name = e.target.name;
        const value = number ? Number(e.target.value) : e.target.value;
        setBookingData((prevState) => ({
            ...prevState,
            [type]: {
                ...prevState[type],
                [name]: value
            }
        }));
    }

    return (
        <div className='orgAddBoBack'>
            <div className='orgAddBoDiv'>
                <h3 className='orgAddBoH1'>Add New Booking</h3>
                <button onClick={() => setAddBo(false)} className='orgAddBoCancel'>
                    <CloseIcon className='orgAddBoCloseIcon' />
                </button>
                <div className='orgAddBoSubDiv'>
                    <div className='dropRegDiv'>
                        <label className='dropRegLabel'>Select Guide</label>
                        <div className='dropRegInputDiv'>
                            <select
                                value={bookingData?.guTourId}
                                name='guTourId'
                                onChange={(e) => {
                                    const value = e.target.value;

                                    if (value === '-1') {
                                        setBookingData({
                                            guTourId: '-1',
                                            people: 1,
                                            date: '',
                                            timeIndex: '',
                                            timeSlots: '',
                                            slotId: '',
                                            language: '',
                                            place: undefined,
                                            selectedPlaceId: undefined,
                                            userDetails: [],
                                            amountPaid: {
                                                actual: 0,
                                                tax: 0,
                                                paid: null,
                                                reserve: 0,
                                                total: 0,
                                                isReserved: false,
                                                isInstallment: false
                                            }
                                        });

                                        return;
                                    }

                                    setBookingData((prev) => ({
                                        ...prev,
                                        guTourId: value,
                                        date: '',
                                        timeIndex: '',
                                        timeSlots: '',
                                        slotId: '',
                                        place: undefined,
                                        selectedPlaceId: undefined
                                    }));
                                }}
                                required={true}
                                className='dropRegSelect'
                            >
                                <option value='-1'>Select</option>
                                {tourList.map(function (val, typeIndex) {
                                    return (
                                        <option key={typeIndex} value={val._id}>
                                            {val.title}
                                        </option>
                                    );
                                })}
                            </select>
                        </div>
                    </div>
                    {bookingData.guTourId && bookingData.guTourId !== '-1' && (
                        <>
                            <div className='dropRegDiv'>
                                <label className='dropRegLabel'>No. of People</label>
                                <div className='dropRegInputDiv'>
                                    <select
                                        value={bookingData.people}
                                        name='people'
                                        onChange={(e) => handleChange(e, setBookingData)}
                                        required={true}
                                        className='dropdownSelect'
                                    >
                                        {numPeople.map(function (val, typeIndex) {
                                            return (
                                                <option key={typeIndex} value={val}>
                                                    {val}
                                                </option>
                                            );
                                        })}
                                    </select>
                                </div>
                            </div>
                            <div className='dropRegDiv'>
                                <label className='dropRegLabel'>Select Place</label>
                                <div onClick={() => setShowSelector(true)} className='dropdownSelect'>
                                    {bookingData?.place?.name || 'Select Place'}
                                </div>
                            </div>
                            {showSelector && (
                                <div className='peopleOverlay' onClick={() => setShowSelector(false)}>
                                    <Close width={30} height={30} style={{ cursor: 'pointer' }} />
                                    <div className='peopleSheet' onClick={(e) => e.stopPropagation()}>
                                        <PlaceSelection
                                            data={packData.price}
                                            setShowSelector={setShowSelector}
                                            booking={bookingData}
                                            setBooking={setBookingData}
                                            packData={packData}
                                        />
                                    </div>
                                </div>
                            )}
                            <div className='dropRegDiv'>
                                <label className='dropRegLabel'>Select Date</label>
                                <div className='dropRegInputDiv'>
                                    <SingleDatePicker
                                        withPortal={isMobile}
                                        date={bookingData.date ? moment(bookingData.date) : null}
                                        onDateChange={(date) => {
                                            if (!date) return;

                                            setBookingData((prev) => ({
                                                ...prev,
                                                date: date.toISOString(),
                                                timeIndex: '',
                                                timeSlots: '',
                                                slotId: ''
                                            }));

                                            setFocusedInput(false);
                                        }}
                                        focused={focusedInput}
                                        onFocusChange={({ focused }) => setFocusedInput(focused)}
                                        displayFormat='DD-MM-YYYY'
                                        numberOfMonths={1}
                                        isOutsideRange={(day) => day.isBefore(moment().startOf('day'))}
                                        showDefaultInputIcon
                                        readOnly
                                    />
                                </div>
                            </div>
                            {bookingData.date && (
                                <>
                                    <div className='dropRegDiv'>
                                        <label className='dropRegLabel'>Select Time Slot</label>
                                        <div className='dropRegInputDiv'>
                                            <select
                                                value={bookingData.timeIndex ?? ''}
                                                name='timeSlots'
                                                onChange={(e) => {
                                                    const index = e.target.value;
                                                    if (index === '') return;
                                                    const selectedSlot = timeSlots[index];

                                                    setBookingData((prev) => ({
                                                        ...prev,
                                                        timeIndex: index,
                                                        timeSlots: {
                                                            startTime: selectedSlot.startTime,
                                                            endTime: selectedSlot.endTime
                                                        },
                                                        slotId: selectedSlot._id
                                                    }));
                                                }}
                                                required={true}
                                                className='dropRegSelect'
                                            >
                                                {timeSlots.length === 0 && bookingData.date ? (
                                                    <option value=''>No time slots available</option>
                                                ) : (
                                                    <>
                                                        <option value=''>Select Time</option>

                                                        {timeSlots.map((val, index) => (
                                                            <option key={index} value={index}>
                                                                {`${val.startTime} - ${val.endTime}`}
                                                            </option>
                                                        ))}
                                                    </>
                                                )}
                                            </select>
                                        </div>
                                    </div>
                                    <div className='dropRegDiv'>
                                        <label className='dropRegLabel'>Select Language</label>
                                        <div className='dropRegInputDiv'>
                                            <select
                                                value={bookingData.language}
                                                name='language'
                                                onChange={(e) => handleChange(e, setBookingData)}
                                                required={true}
                                                className='dropRegSelect'
                                            >
                                                <option value='' disabled>
                                                    Select Language
                                                </option>
                                                {packData?.quickView?.languages?.map(function (val, typeIndex) {
                                                    return (
                                                        <option key={typeIndex} value={val}>
                                                            {val}
                                                        </option>
                                                    );
                                                })}
                                            </select>
                                        </div>
                                    </div>
                                    <div className='dropRegDiv'>
                                        <label className='dropRegLabel'>Select Meetup Location</label>

                                        <div className='dropRegInputDiv'>
                                            <select
                                                value={bookingData?.meetupLocation?.name || ''}
                                                onChange={(e) => {
                                                    const selectedLocation = meetUpPoints.find(
                                                        (item) => item.name === e.target.value
                                                    );

                                                    setBookingData((prev) => ({
                                                        ...prev,
                                                        meetupLocation: {
                                                            name: selectedLocation.name,
                                                            location: selectedLocation.location
                                                        }
                                                    }));
                                                }}
                                                required
                                                className='dropRegSelect'
                                            >
                                                <option value='' disabled>
                                                    Select Meetup Point
                                                </option>

                                                {meetUpPoints?.map((val, index) => (
                                                    <option key={index} value={val.name}>
                                                        {val.name}
                                                    </option>
                                                ))}
                                            </select>
                                        </div>
                                    </div>
                                    <Price
                                        bookingData={bookingData}
                                        handleAmount={handleAmount}
                                        isReservePrice={packData.price?.[0]?.reserve > 0}
                                    />
                                    {bookingData.people > 0 && (
                                        <UserDetails bookingData={bookingData} handleUser={handleUser} />
                                    )}
                                    <div className='orgAddBoBtn'>
                                        <button
                                            type='button'
                                            name='ManualBookingSubmit'
                                            className='orgAddBoSubmit blueBtn'
                                            onClick={() => handleSubmit('gu', bookingData, packData, setAddBo)}
                                        >
                                            Submit
                                        </button>
                                    </div>
                                </>
                            )}
                        </>
                    )}
                </div>
            </div>
        </div>
    );
}
